'use client';

import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import { FC, useRef } from 'react';
import CaseSlide from '@/components/CasesChunkedSlider/CaseSlide';
import { useGridInitialAnimation } from '@/components/CaseStudiesPage/GridCaseStudies/hooks/useGridInitialAnimation';
import CasesSliderDesktop from '@/components/Partnership/CasesSliderScroll/components/CasesSliderDesktop';
import { getLayoutFromData } from '@/components/Partnership/CasesSliderScroll/utils/getLayoutFromData';
import { mapCasesScrollItemToSlideItem } from '@/components/Partnership/CasesSliderScroll/utils/mapCasesScrollItemToSlideItem';
import { BrandStoriesSectionDto } from '@/components/ServicesLobbyPage/BrandStoriesSection/types';
import TitleGraffiti from '@/components/shared/TitleGraffiti';
import useDevice from '@/hooks/useDevice';
import css from './style.module.scss';
interface Props {
  data: BrandStoriesSectionDto;
}
const BrandStoriesSection: FC<Props> = t0 => {
  const $ = _c(18);
  const {
    data
  } = t0;
  const device = useDevice();
  const isMobile = device === "mobile";
  const wrapperRef = useRef(null);
  let t1;
  if ($[0] !== data.cases) {
    t1 = data.cases ?? [];
    $[0] = data.cases;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = getLayoutFromData(t1, true);
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const layout = t2;
  let t3;
  if ($[4] !== data.cases) {
    t3 = data.cases ?? [];
    $[4] = data.cases;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = !isMobile;
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = {
      wrapperRef,
      displayedItems: t3,
      cssItemsSelector: ".case-item",
      disabled: t4
    };
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  useGridInitialAnimation(t5);
  let t6;
  if ($[9] !== data.title) {
    t6 = data.title ? <TitleGraffiti className={clsx("container", css.titleWrapper)} url="/assets/video/mp4/graffity-heart-x.mp4" title={data.title} /> : null;
    $[9] = data.title;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== data.cases || $[12] !== isMobile || $[13] !== layout) {
    t7 = isMobile ? <ul className={clsx("container", css.grid)}>{data.cases.map(_temp)}</ul> : <CasesSliderDesktop cases={data.cases} layout={layout} withContainer={false} />;
    $[11] = data.cases;
    $[12] = isMobile;
    $[13] = layout;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6 || $[16] !== t7) {
    t8 = <section ref={wrapperRef} className={css.section}>{t6}{t7}</section>;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
};
export default BrandStoriesSection;
function _temp(caseItem) {
  return <div key={caseItem.id} className="case-item"><CaseSlide data={mapCasesScrollItemToSlideItem(caseItem)} width={100} withOverlay={false} hideDefaultCursor={false} /></div>;
}